export default __webpack_public_path__ + "static/media/CA.94721a0e.png";